/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Tea_GradesInputs */

const vi_nav_tea_grades = /** @type {(inputs: Nav_Tea_GradesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại phân loại`)
};

/**

* @param {Nav_Tea_GradesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_tea_grades = /** @type {((inputs?: Nav_Tea_GradesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Tea_GradesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_tea_grades(inputs)
});